import { FC } from 'react'
import {
  Button,
  FetchState,
  FormInput,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { EmpresaDtoUpdate, EmpresaView } from '../../../../empresa/empresas-list/core/_models'
import { useFormik } from 'formik'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { WebHookSchema } from './validation/WebHookSchema'
import { updateEmpresa } from '../../../../empresa/empresas-list/core/_requests'
import { useT } from '_metronic/i18n/Metronici18n'

export const WebHookModal: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: empresa } = (fetchStates['empresa'] || {}) as FetchState<EmpresaView>

  const formik = useFormik({
    initialValues: { apiWebhook: empresa?.apiWebhook || '' },
    validationSchema: WebHookSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const empresaUpdate: EmpresaDtoUpdate = {
          id: Number(empresa?.id),
          apiWebhook: values.apiWebhook,
          cnpj: empresa?.cnpj as string,
        }
        await updateEmpresa(empresaUpdate)
        await showAlert({
          title: 'Sucesso!',
          text: 'WebHook configurado com sucesso!',
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormInput formik={formik} placeholder='Insira a URL do WebHook' name='apiWebhook' />

      <div className='d-flex justify-content-center mt-5'>
        <Button className='btn-secondary me-3' onClick={closeModal}>
          Fechar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
    </form>
  )
}
